import { IconCloudUpload } from '@tabler/icons-react';
import { Button, Grid, Modal, Text, TextInput } from '@mantine/core';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import FileUpload from '../FileUpload';

const SearchAsYouTypeUploadModal = ({ show, close }) => {
  const [file, setFile] = useState();
  const [label, setLabel] = useState();
  const [uploading, setUploading] = useState();
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();

  const fetch = useFetch();

  const upload = () => {
    if (!file) {
      return;
    }
    setUploading(true);
    let fd = new FormData();
    fd.append('file', file);
    fd.append('label', label);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/search/synonyms`, {
      method: 'POST',
      headers: {},
      body: fd,
    })
      .then(({ synonymFile }) => {
        setUploading(false);
        setFile(undefined);
        close(synonymFile);
      })
      .catch(setError);
  };

  return (
    <Modal opened={show} onClose={() => close()} title="Upload reference synonym file">
      <Grid>
        <Grid.Col span={12}>
          <FileUpload onFileSet={(files) => setFile(files[0])} />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            name="label"
            type="text"
            value={label}
            placeholder="File label..."
            onChange={(event) => setLabel(event.target.value)}
          />
        </Grid.Col>
      </Grid>
      <Text size="sm" c="dimmed">Please import a CSV file with every row represents synonym pair.</Text>
      <div style={{ textAlign: 'right' }}>
        <ErrorMessage message={error} style={{ float: 'right' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
        <ErrorMessage message={error} style={{ float: 'right' }} />
        <Button variant="default" onClick={() => close()}>
          Close
        </Button>
        <Button disabled={!file || uploading || !label} onClick={upload}>
          Upload <IconCloudUpload size={14} />
        </Button>
      </div>
    </Modal>
  );
};

export default SearchAsYouTypeUploadModal;
